import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  generatePin: { open: false, data: null },
  completeServiceRecord: { open: false, machineId: null },
  machineSearchService: { open: false },
  requestSoftware: { open: false, machineId: null },
  diffViewer: { open: false, data: null },
  addMachine: { open: false },
  editMachine: { open: false, machine: null },
  addComment: { open: false, runCommentTime: null, runId: null },
  editComment: { open: false, comment: null },
  addUser: { open: false, users: [], roles: [] },
  editUser: { open: false, user: null, roles: [] },
  uploadLog: { open: false, serialNumber: null },
  deleteSoftware: { open: false, softwareId: null },
  softwareInfo: { open: false, software: null },
  uploadSoftware: { open: false },
  editSoftware: { open: false, software: null }
};

export const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    setGeneratePin: (state, action) => {
      state.generatePin = { ...action.payload };
    },
    setCompleteServiceRecord: (state, action) => {
      state.completeServiceRecord = { ...action.payload };
    },
    setMachineSearchService: (state, action) => {
      state.machineSearchService = { ...action.payload };
    },
    setRequestSoftware: (state, action) => {
      state.requestSoftware = { ...action.payload };
    },
    setDiffViewer: (state, action) => {
      state.diffViewer = { ...action.payload };
    },
    setUploadSoftware: (state, action) => {
      state.uploadSoftware = { ...action.payload };
    },
    setAddMachine: (state, action) => {
      state.addMachine = { ...action.payload };
    },
    setAddComment: (state, action) => {
      state.addComment = { ...action.payload };
    },
    setEditMachine: (state, action) => {
      state.editMachine = { ...action.payload };
    },
    setEditComment: (state, action) => {
      state.editComment = { ...action.payload };
    },
    setAddUser: (state, action) => {
      state.addUser = { ...action.payload };
    },
    setEditUser: (state, action) => {
      state.editUser = { ...action.payload };
    },

    setUploadLog: (state, action) => {
      state.uploadLog = { ...action.payload };
    },
    setDeleteSoftware: (state, action) => {
      state.deleteSoftware = { ...action.payload };
    },
    setSoftwareInfo: (state, action) => {
      state.softwareInfo = { ...action.payload };
    },
    setEditSoftware: (state, action) => {
      state.editSoftware = { ...action.payload };
    }
  }
});

export const {
  setGeneratePin,
  setCompleteServiceRecord,
  setMachineSearchService,
  setRequestSoftware,
  setDiffViewer,
  setAddMachine,
  setAddComment,
  setEditMachine,
  setEditComment,
  setAddUser,
  setEditUser,
  setUploadLog,
  setDeleteSoftware,
  setSoftwareInfo,
  setUploadSoftware,
  setEditSoftware
} = modalSlice.actions;
export default modalSlice.reducer;
